export default __webpack_public_path__ + "static/media/envios.731978c1.png";